import { useRef, useState } from 'react';

export default function ScreenshotGallery({ urls }: { urls: string[] }) {
  const [active, setActive] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);
  const scrollerRef = useRef<HTMLDivElement>(null);

  if (urls.length === 0) {
    return (
      <div className="flex h-64 w-full items-center justify-center bg-mlbb-border/40 text-4xl opacity-30">🎮</div>
    );
  }

  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const idx = Math.round(el.scrollLeft / el.clientWidth);
    setActive(idx);
  };

  return (
    <div className="relative">
      <div
        ref={scrollerRef}
        onScroll={handleScroll}
        className="flex h-64 w-full snap-x snap-mandatory overflow-x-auto scroll-smooth"
        style={{ scrollbarWidth: 'none' }}
      >
        {urls.map((url, i) => (
          <img
            key={url}
            src={url}
            alt=""
            loading={i === 0 ? 'eager' : 'lazy'}
            onClick={() => setFullscreen(true)}
            className="h-64 w-full shrink-0 snap-center object-cover"
          />
        ))}
      </div>

      {urls.length > 1 && (
        <div className="absolute bottom-2 left-0 flex w-full justify-center gap-1.5">
          {urls.map((url, i) => (
            <div
              key={url}
              className={`h-1.5 rounded-full transition-all ${
                i === active ? 'w-4 bg-white' : 'w-1.5 bg-white/40'
              }`}
            />
          ))}
        </div>
      )}

      {fullscreen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black"
          onClick={() => setFullscreen(false)}
        >
          <img src={urls[active]} alt="" className="max-h-full max-w-full object-contain" />
          <button
            type="button"
            onClick={() => setFullscreen(false)}
            className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-lg text-white"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}
